import apiService from './ApiService';

const AsistentesClasicosService = {
  async crearAsistente(formData) {
    try {
      const response = await apiService.request('/AsistentesClasicos/crear', {
        method: 'POST',
        body: formData,
        headers: {}
      });

      if (!response.ok) {
        throw new Error(response.error || 'Error al crear el asistente clásico');
      }

      return response;
    } catch (error) {
      console.error('❌ Error al crear asistente clásico:', error);
      throw error;
    }
  },

  async actualizarAsistente(idOpenAIAssistant, formData) {
    try {
      const response = await apiService.request(`/AsistentesClasicos/${idOpenAIAssistant}`, {
        method: 'PUT',
        body: formData,
        headers: {}
      });

      if (!response.ok) {
        throw new Error(response.error || 'Error al actualizar el asistente clásico');
      }

      return response;
    } catch (error) {
      console.error('❌ Error al actualizar asistente clásico:', error);
      throw error;
    }
  }
  ,
  async getAsistente(idOpenAIAssistant) {
    try {
      const response = await apiService.request(`/AsistentesClasicos/${idOpenAIAssistant}`, {
        method: 'GET'
      });

      if (!response.ok) {
        throw new Error(response.error || 'Error al obtener el GPT clásico');
      }

      return response;
    } catch (error) {
      console.error('❌ Error al obtener GPT clásico:', error);
      throw error;
    }
  },
  async getMisAsistentes() {
    try {
      const response = await apiService.request('/AsistentesClasicos/mis-asistentes', {
        method: 'GET'
      });

      if (!response.ok) {
        throw new Error(response.error || 'Error al obtener los GPTs clásicos');
      }

      return response;
    } catch (error) {
      console.error('❌ Error al obtener GPTs clásicos:', error);
      throw error;
    }
  }
};

export default AsistentesClasicosService;
